<script lang="ts" setup>
import { computed } from 'vue';
import { useBlockLibraryStore } from '#layers/block-engine/composables/block-editor/library';

const { blockId } = defineProps<{
	blockId: string;
}>();

const { getBlock } = useBlockLibraryStore();

const block = computed(() => getBlock(blockId));
</script>

<template>
	<div v-if="block" class="flex items-center justify-center gap-2 rounded-sm bg-default p-2 opacity-75">
		<DIconOrImage
			:icon="block.icon || 'lucide:box'"
			class="size-6 flex-none"
		/>

		<div>
			{{ block.name }}
		</div>
	</div>
</template>
